window._ = require('lodash');

let backgroundElement = document.querySelector('.home_background');
let startBackgroundId = parseInt(backgroundElement.dataset.backgroundId);

let available = ['bg1', 'bg2', 'bg3', 'bg4', 'bg5', 'bg6', 'bg7'];
available.splice(available.indexOf(`bg${startBackgroundId}`), 1);
let images = _.shuffle(available);
images.unshift('bg' + (startBackgroundId));

originalImages = images;

images = _(images);
images.next();

setInterval(function() {
    image = images.next();

    if (image.value === undefined) {
        images = _(originalImages);
        image = images.next();
    }

    originalImages.forEach((el) => {
        if (el === image.value) {
            backgroundElement.classList.add(el);
        } else {
            backgroundElement.classList.remove(el);
        }
    });
}, 7500);
